import { render, staticRenderFns } from "./SearchIcon.vue?vue&type=template&id=10832448&scoped=true"
import script from "./SearchIcon.vue?vue&type=script&lang=js"
export * from "./SearchIcon.vue?vue&type=script&lang=js"
import style0 from "./SearchIcon.vue?vue&type=style&index=0&id=10832448&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10832448",
  null
  
)

export default component.exports